<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="saveButtonAction" title="Save Confirmation - Approval Configuration Instance">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name">
						{{ model != null ? model.name : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-instance" label-cols-sm="4" label-cols-lg="3" label="Approval Instance" label-for="filter-approval-instance">
						{{ model != null ? model.approvalInstance : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-type" label-cols-sm="4" label-cols-lg="3" label="Approval Type" label-for="filter-approval-type">
						{{ model != null ? ( model.approvalType != null ? model.approvalType.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="filter-description">
						{{ model != null ? model.description : "" }}
					</b-form-group>
					<b-form-group id="fieldset-applied-to" label-cols-sm="4" label-cols-lg="3" label="Applied To" label-for="filter-applied-to">
						{{ model != null ? ( model.appliedTo != null ? model.appliedTo.name : "") : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
<!--APP_DETAIL_TABLE-->
	<b-card class="mt-3" header-bg-variant="transparent">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approval Configuration Instance Details</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approvalConfigurationInstanceDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalConfigurationInstanceDetails" :fields="fieldsApprovalConfigurationInstanceDetail" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationInstanceDetail" :sort-desc.sync="sortDescApprovalConfigurationInstanceDetail" small responsive>
			<!--APP_TABLE_FILTER-->
			<template v-slot:head(actions)>
				<b-button @click="isShowApprovalConfigurationInstanceDetailFilter = !isShowApprovalConfigurationInstanceDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowApprovalConfigurationInstanceDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes" :value="filterApprovalConfigurationInstanceDetail.approverTypeId" :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalConfigurationInstanceDetail.approvalStructureId" :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationInstanceDetail.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User Name">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalConfigurationInstanceDetail.approverUserNameId" :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approverUserNameId" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationInstanceDetail.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationInstanceDetail.approvalType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Configuration Content">
					<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationInstanceDetail.configurationContent" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApprovalConfigurationInstanceDetail.isSendNotification"></b-form-checkbox>
				</b-th>
				<b-th></b-th>
			</template>
			<!--END_APP_TABLE_FILTER-->
			<!--APP_TABLE_DATA-->
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approvalConfigurationInstanceDetailPageSize * (currentApprovalConfigurationInstanceDetailPage - 1))) }}
			</template>
			<template v-slot:cell(approvalConfigurationInstance)="row">
				{{ row.item.approvalConfigurationInstance != null ? row.item.approvalConfigurationInstance.name : "" }}
			</template>
			<template v-slot:cell(approverType)="row">
				{{ row.item.approverType != null ? row.item.approverType.name : "" }}
			</template>
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(approverUserName)="row">
				{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
			</template>
			<!--END_APP_TABLE_DATA-->
			</b-table>
			</div>
		</b-col>
		<b-col cols="12">
			<!--APP_TABLE_PAGINATION-->
			<b-pagination
			class="float-right btn-paging"
			v-model="currentApprovalConfigurationInstanceDetailPage"
			:total-rows="totalApprovalConfigurationInstanceDetailRow"
			:per-page="approvalConfigurationInstanceDetailPageSize"
			aria-controls="my-table"
			></b-pagination>
			<!--END_APP_TABLE_PAGINATION-->
		</b-col>
		</b-row>
	</b-card>
<!--END_APP_DETAIL_TABLE-->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalConfigurationInstanceList from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceList';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';

import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	/*APP_DETAIL_PROP_DEFINITION*/
	props : ["openPopup", "modelId", "saveActionMethod", "resetMethod"],
	/*END_APP_DETAIL_PROP_DEFINITION*/
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			model: {},
			datas: Array(),
			fieldsApprovalConfigurationInstanceDetail: [
				{"no" : {  "class" : "th-number" }},
				{"approverType": {},  "class" : "th-approver-type", "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": {},  "class" : "th-approval-structure", "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": {},  "class" : "th-approver-level", "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUserName": {},  "class" : "th-approver-user-name", "label" : "Approver User Name", key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": {},  "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"approvalType": {},  "class" : "th-approval-type", "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"configurationContent": {},  "class" : "th-configuration-content", "label" : "Configuration Content", key: 'configurationContent', sortable: true}, 
				{"isSendNotification": {},  "class" : "th-is-send-notification", "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			/*APP_DETAIL_PAGINATION*/
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterApprovalConfigurationInstance : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentApprovalConfigurationInstancePage : 1,
			approvalConfigurationInstancePageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByApprovalConfigurationInstance: '',
			sortDescApprovalConfigurationInstance: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			filterApprovalConfigurationInstanceDetail : null,
			currentApprovalConfigurationInstanceDetailPage : 1,
			approvalConfigurationInstanceDetailPageSize: 10,
			sortByApprovalConfigurationInstanceDetail: '',
			sortDescApprovalConfigurationInstanceDetail: '',
			sortingByApprovalConfigurationInstanceDetail: [],
			approvalConfigurationInstanceDetails : [],
			approvalConfigurationInstanceDetailId : '',
			totalApprovalConfigurationInstanceDetailRow : 0,
			isShowApprovalConfigurationInstanceDetailFilter: false,
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETApprovalConfigurationInstance*/
		getApprovalConfigurationInstance : async function(id) {
			this.isBusy = true;
			ApprovalConfigurationInstance.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETApprovalConfigurationInstance*/
		/*APP_DETAIL_GETApprovalConfigurationInstanceDetail*/
		getApprovalConfigurationInstanceDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationInstanceDetail);
			if (this.modelId == null) return;
			filter.approvalConfigurationInstanceId = this.modelId;
			this.sortingByApprovalConfigurationInstanceDetail = Array();
			if (this.sortByApprovalConfigurationInstanceDetail != null) {
				this.sortingByApprovalConfigurationInstanceDetail[this.sortByApprovalConfigurationInstanceDetail] = this.sortDescApprovalConfigurationInstanceDetail;
			}
			let currentPage = (this.currentApprovalConfigurationInstanceDetailPage - 1);
			ApprovalConfigurationInstanceDetail.getList(this, filter, this.sortingByApprovalConfigurationInstanceDetail, currentPage , this.approvalConfigurationInstanceDetailPageSize).then(result => {
				this.approvalConfigurationInstanceDetails = result.data;
				this.totalApprovalConfigurationInstanceDetailRow = result.dataCount;
			}).catch(error => {});
		},
		/*END_APP_DETAIL_GETApprovalConfigurationInstanceDetail*/
		/*APP_DETAIL_GETAPPROVERTYPE*/
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVERTYPE*/
		/*APP_DETAIL_GETAPPROVALSTRUCTURE*/
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETAPPROVALSTRUCTURE*/
		/*APP_DETAIL_GETUSERINFO*/
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETUSERINFO*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'approvalconfigurationinstancecopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_SAVEBUTTONACTION*/
		saveButtonAction(modalEvent) {
			this.$emit("saveActionMethod", modalEvent);
		},
		/*END_APP_DETAIL_SAVEBUTTONACTION*/
		/*APP_DETAIL_RESETMODAL*/
		resetModal() {
			this.$emit('resetMethod'); 
		},
		/*END_APP_DETAIL_RESETMODAL*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApprovalConfigurationInstanceDetailFilter = true;
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterApprovalConfigurationInstance = new ApprovalConfigurationInstanceFilter();
		this.filterApprovalConfigurationInstanceDetail = new ApprovalConfigurationInstanceDetailFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	watch : {
		/*APP_DETAIL_OPENPOPUP*/
		openPopup(newValue, oldValue) {
			if (newValue) {
				this.getApprovalConfigurationInstance(this.modelId);
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		/*END_APP_DETAIL_OPENPOPUP*/
		/*APP_DETAIL_WATCH_APPROVALCONFIGURATIONINSTANCEDETAIL*/
		sortByApprovalConfigurationInstanceDetail : {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		sortDescApprovalConfigurationInstanceDetail: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		currentApprovalConfigurationInstanceDetailPage: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		approvalConfigurationInstanceDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		filterApprovalConfigurationInstanceDetail: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			},
			deep: true,
		},
		/*END_APP_DETAIL_WATCH_APPROVALCONFIGURATIONINSTANCEDETAIL*/
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
		isShowPopup: {
			get: function(){
				if (this.openPopup) return true; 
				else return false; 
			},
			set: function(newValue){ }
		},
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
